import { cx } from './cx.ts';
import { DataTag } from './DataTag.tsx';
import s from './MoneyReadout.module.css';
import t from './type.module.css';

export type MoneyStatus = { kind: 'paid' } | { kind: 'due'; date: string } | { kind: 'planned' };

/**
 * C-06 Money readout: the entered (or local) amount, then PHP and EUR in fixed order. Amounts
 * arrive formatted (the money package owns rounding, F-09); this only lays them out.
 */
export function MoneyReadout({
  primary,
  secondary = [],
  status,
  variant = 'row',
}: {
  primary: string;
  secondary?: string[];
  status?: MoneyStatus;
  variant?: 'row' | 'inline' | 'total';
}) {
  if (variant === 'inline') return <span className={t.readoutS}>{[primary, ...secondary].join(' · ')}</span>;
  return (
    <span className={cx(s.stack, variant === 'row' && s.row)}>
      <span className={variant === 'total' ? t.readoutXL : t.readoutM}>{primary}</span>
      {secondary.length > 0 && <span className={cx(t.readoutS, s.secondary)}>{secondary.join(' · ')}</span>}
      {status?.kind === 'paid' && <DataTag label="Paid ✓" spoken="Paid" />}
      {status?.kind === 'due' && <DataTag label="Due" value={status.date} tone="hazard" spoken="Due" />}
      {status?.kind === 'planned' && <span className={cx(t.label, s.planned)}>Planned</span>}
    </span>
  );
}
